import { memo } from "react";
import {
  SignApplication as SignApplicationImage,
  Signed as SignedImage,
  Revoked as RevokedImage,
  ApplicationProcessed as ApplicationProcessedImage,
  AddSignature as AddSignatureImage,
} from "@rshbintech.dboul/images";
import { SIGNING_STATUSES } from "../../constants";
import { SigningWidgetImageProps } from "./types";

export const SigningWidgetImage = memo(
  ({ status }: SigningWidgetImageProps) => {
    let widgetImage;
    const widgetImageProps = {
      width: 128,
      height: 128,
    };

    switch (status) {
      case SIGNING_STATUSES.READY_TO_BE_SIGNED:
        widgetImage = <SignApplicationImage {...widgetImageProps} />;
        break;

      case SIGNING_STATUSES.IS_SIGNING:
        widgetImage = <AddSignatureImage {...widgetImageProps} />;
        break;

      case SIGNING_STATUSES.ERROR:
        widgetImage = <RevokedImage {...widgetImageProps} />;
        break;

      case SIGNING_STATUSES.SIGNING_STOPPED:
        widgetImage = <RevokedImage {...widgetImageProps} />;
        break;

      case SIGNING_STATUSES.SIGNING_COMPLETED:
        widgetImage = <SignedImage {...widgetImageProps} />;
        break;

      case SIGNING_STATUSES.CHECKING_SIGNING_POSSIBILITY:
        widgetImage = <ApplicationProcessedImage {...widgetImageProps} />;
        break;

      default:
        widgetImage = <RevokedImage {...widgetImageProps} />;
        break;
    }

    return <>{widgetImage}</>;
  }
);
